export default __webpack_public_path__ + "static/media/LOGO_TITULO_ORG_48.a45a0e8e.png";